import React from "react";
import { BookOpenIcon, BrainIcon, ClipboardListIcon, CompassIcon, SearchIcon, TimerIcon, BoxIcon } from "lucide-react";
import { painPoints } from "../../data/content";
import { CtaButton } from "../CtaButton";
const icons: Record<string, BoxIcon> = {
  compass: CompassIcon,
  timer: TimerIcon,
  brain: BrainIcon,
  clipboard: ClipboardListIcon,
  search: SearchIcon,
  book: BookOpenIcon
};
export function PainPoints() {
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-230" data-mp="2hix3tugendja">
      <div className="mx-auto max-w-4xl" data-id="element-231" data-mp="2clnfki4r57x1">
        <h2 className="text-center font-serif text-[2rem] font-extrabold leading-tight text-navy sm:text-5xl" data-id="element-232" data-mp="2ckvl5amw5g8c">
          Do any of these sound <span className="italic text-teal" data-id="element-233" data-mp="2qityccph76m9">familiar?</span>
        </h2>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-234" data-mp="2mkcp9nmhvm27">
          {painPoints.map(p => {
          const Icon = icons[p.icon];
          return <li key={p.text} className="flex items-start gap-4 rounded-2xl bg-cream p-5" data-id="element-235" data-mp="s5jz444drnhn">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy text-teal-light" data-id="element-236" data-mp="1n7tn0bwabpe9">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-237" data-mp="1s6d9qeipd57o" />
                </span>
                <p className="text-[17px] leading-snug text-ink" data-id="element-238" data-mp="1x69c69br4ol4">{p.text}</p>
              </li>;
        })}
        </ul>

        <div className="mt-12 text-center" data-id="element-239" data-mp="21wzibos04vgv">
          <p className="font-serif text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-240" data-mp="21y0y26jyq64x">And it doesn’t have to stay that way.</p>
          <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-ink-muted" data-id="element-241" data-mp="2axe6cvwcooo2">
            The problem isn’t necessarily that I need more information. The problem is that information becomes much harder to use when I don’t have a{" "}
            <strong className="text-navy" data-id="element-242" data-mp="2kuircsegme3a">structured system for organizing it.</strong>
          </p>
        </div>

        <CtaButton label="I want a structured planning system" className="mt-10" data-id="element-243" data-mp="lk0ywxsxykiq" />
      </div>
    </section>;
}